'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$scope', 'StatusService',
    function ($scope, StatusService) {
        $scope.statuses = [];
        $scope.getDisplayName = StatusService.getDisplayName;
        StatusService.api.get({type: "HANDBOOK"}, (data) => $scope.statuses = data._embedded);
    }];